<div
  class="p-6 relative banner-background rounded transition-[margin-bottom] duration-300"
  [class.-mb-2]="isCollapsed$ | async"
  [class.rounded-t]="isCollapsed$ | async"
>
  <div class="flex justify-between items-center w-full">
    <div>
      <div class="flex gap-2 cursor-pointer" (click)="toggleVisibility()">
        <h2
          class="text-white text-xl font-bold"
          [class.mb-3]="(isCollapsed$ | async) === false"
        >
          {{ 'publishing-banner.title' | translate }}
        </h2>
        <fa-icon
          icon="chevron-down"
          class="text-white opacity-70 origin-center"
          [class.rotate-180]="isCollapsed$ | async"
        ></fa-icon>
      </div>
      @if ((isCollapsed$ | async) === false) {
        <p class="text-white opacity-70">
          {{ 'publishing-banner.description' | translate }}
          <a class="underline" [href]="'publishing-banner.link' | translate" target="_blank">{{ 'publishing-banner.link-description' | translate }}</a>
        </p>
      }
    </div>
    <rk-button
      class="ml-6"
      text="{{ 'publishing-banner.cta' | translate }}"
      (buttonClick)="onCtaClick()"
    ></rk-button>
  </div>
</div>
